import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APP = "Қаржы орталығы";

const titles: { test: (path: string) => boolean; title: string }[] = [
  { test: (path) => path === "/login", title: "Вход" },
  { test: (path) => path === "/reset", title: "Сброс пароля" },
  { test: (path) => path === "/home" || path === "/", title: "Дашборд" },
  { test: (path) => /^\/report\/[^/]+\/student\//.test(path), title: "Студент в отчёте" },
  { test: (path) => path === "/report/upload-manual", title: "Загрузка отчёта" },
  { test: (path) => path.startsWith("/report/"), title: "Отчёт" },
  { test: (path) => path === "/report", title: "Отчеты" },
  { test: (path) => path.startsWith("/student/"), title: "Студент" },
  { test: (path) => path === "/student", title: "Студенты" },
  { test: (path) => path.startsWith("/student-scholarship"), title: "Справка о стипендии" },
  { test: (path) => path.startsWith("/epvo-student"), title: "Сведения о студенте" },
  { test: (path) => path.startsWith("/kdp"), title: "КДП" },
  { test: (path) => path.startsWith("/gbdfl"), title: "ГБД ФЛ" },
  { test: (path) => path.startsWith("/gbdul"), title: "ГБД ЮЛ" },
  { test: (path) => path.startsWith("/unemployed"), title: "Безработные (МТСЗН)" },
  { test: (path) => path.startsWith("/esobes"), title: "Е-Собес" },
  { test: (path) => path.startsWith("/nobd"), title: "НОБД" },
  { test: (path) => path.startsWith("/university-responsible"), title: "Назначение менеджеров" },
  { test: (path) => path.startsWith("/university/"), title: "Вуз" },
  { test: (path) => path === "/university", title: "Вузы" },
  { test: (path) => path.startsWith("/dictionaries/citizenship"), title: "Гражданство" },
  { test: (path) => path.startsWith("/dictionaries/gop"), title: "ГОП" },
  { test: (path) => path.startsWith("/dictionaries/degree"), title: "Академическая степень" },
  { test: (path) => path.startsWith("/dictionaries/university"), title: "Справочник вузов" },
  { test: (path) => path.startsWith("/dictionaries"), title: "Справочники" },
  { test: (path) => /^\/shep-logs\/history\/\d+/.test(path), title: "История обмена" },
  { test: (path) => path.startsWith("/shep-logs"), title: "Логи ШЭП" },
  { test: (path) => path.startsWith("/integration-logs"), title: "Логи интеграций" },
  { test: (path) => path.startsWith("/message"), title: "Почта" },
  { test: (path) => path.startsWith("/scholarship-calculator"), title: "Калькулятор стипендии" },
];

const DocumentTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = titles.find((item) => item.test(pathname))?.title;
    document.title = page ? `${page} — ${APP}` : APP;
  }, [pathname]);

  return null;
};

export default DocumentTitle;
